<!--Designed & Developed by:
   Nirmal K (@cyberwizard1001)⁶
   Nitin Ravi (@nitinravi)
   Ritwik M (@ritwik-m) &
   Nalinadevi K (@knaldev)
for the Ministry of Education (MOE) virtual-labs project, Govt. Of India -->

<script>

import abstractComponent from "../components/help/abstractComponent.vue";
import arrayListComponent from "../components/help/arrayListComponent.vue";
import addToArrayComponent from "./help/addToArrayComponent.vue";
import arraysComponent from "./help/arraysComponent.vue";
import arrayOfObjects from "./help/arrayOfObjects.vue";
import classCastExceptionComponent from "../components/help/classCastExceptionComponent.vue";
import constructorWritingComponent from "../components/help/constructorWritingComponent.vue";
import dateComponent from "../components/help/dateComponent.vue";
import extendsComponent from "../components/help/extendsComponent.vue";
import functionCallingWithObjectComponent from "../components/help/functionCallingWithObjectComponent.vue";
import getterComponent from "../components/help/getterComponent.vue";
import interfaceComponent from "../components/help/interfaceComponent.vue";
import newVariableComponent from "../components/help/newVariableComponent.vue";
import nullPointerExceptionComponent from "../components/help/nullPointerExceptionComponent.vue";
import objectCreationComponent from "../components/help/objectCreationComponent.vue";
import parseExceptionComponent from "../components/help/parseExceptionComponent.vue";
import passingArgumentsToFunctionsComponent from "../components/help/passingArgumentsToFunctionsComponent.vue";
import printFunctionComponent from "../components/help/printFunctionComponent.vue";
import setterComponent from "../components/help/setterComponent.vue";
import stringCompareComponent from "../components/help/StringcompareComponent.vue";
import superKeywordComponent from "../components/help/superKeywordComponent.vue";
import thisComponent from "../components/help/thisComponent.vue";
import tryCatchComponent from "../components/help/tryCatchComponent.vue";
import typeCastingComponent from "./help/typeCastingComponent.vue";
import behavioralComponent from "./help/behavioralComponent.vue";
import builderComponent from "./help/builderComponent.vue";
import decoratorComponent from "./help/decoratorComponent.vue";
import factoryComponent from "./help/factoryComponent.vue";
import iteratorComponent from "./help/iteratorComponent.vue";
import singletonComponent from "./help/singletonComponent.vue";
import structuralComponent from "./help/structuralComponent.vue";


export default {
  components: {
    abstractComponent,
    arrayListComponent,
    addToArrayComponent,
    arraysComponent,
    arrayOfObjects,
    classCastExceptionComponent,
    constructorWritingComponent,
    dateComponent,
    extendsComponent,
    functionCallingWithObjectComponent,
    getterComponent,
    interfaceComponent,
    newVariableComponent,
    nullPointerExceptionComponent,
    objectCreationComponent,
    parseExceptionComponent,
    passingArgumentsToFunctionsComponent,
    printFunctionComponent,
    setterComponent,
    stringCompareComponent,
    superKeywordComponent,
    thisComponent,
    tryCatchComponent,
    typeCastingComponent,
    behavioralComponent,
    builderComponent,
    decoratorComponent,
    factoryComponent,
    iteratorComponent,
    singletonComponent,
    structuralComponent
  },
  methods: {
    popup(chosenComponent) {
      this.currentComponent = chosenComponent;
      console.log("popup")
      var modal = document.getElementById("myModal");
      console.log(modal)
      var span = document.getElementsByClassName("close")[0];
        modal.style.display = "block";
        console.log(modal.style.display)
      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        modal.style.display = "none";
      }

      // When the user clicks anywhere outside of the modal, close it
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      }
    },
    correct1() {
      var x = document.getElementById("snackbar");
      x.innerHTML = "Correct";
      x.style.backgroundColor = "green";
      x.className = "show";
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000)
    },
    incorrect() {
      var x = document.getElementById("snackbar");
      x.innerHTML = "Incorrect. Try again";
      x.style.backgroundColor = "red";
      x.className = "show";
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000)
    },
    validate_one() {
      console.log(this.one, this.two);
      if (this.one == "Person" && this.two == "ArrayList") {
        this.correct1();
        this.display[0] = "none";
        this.display[1] = "block";
      } else {
        this.incorrect();
      }
    },

    validate_two() {
      if (this.three == "add" && this.four == "Exec") {
        this.correct1();
        this.display[1] = "none";
        this.display[2] = "block";
      } else {
        this.incorrect();
      }
    },

    validate_three() {
      if (this.five == "add" && this.six == "Customer") {
        this.correct1();
        this.display[2] = "none";
        this.display[3] = "block";
      } else {
        this.incorrect();
      }
    },
    validate_four() {
      if (this.a == "Customer" && this.b == "ArrayList") {
        this.correct1();
        this.display[3] = "none";
        this.display[4] = "block";

      } else {
        this.incorrect();
      }

    },
    validate_free() {
      // eslint-disable-next-line no-constant-condition
      if (1 == 1) {
        this.correct1();
        this.display[4] = "none";
        this.display[5] = "block";

      } else {
        this.incorrect();
      }

    },
    validate_free2() {
      if (1 == 1) {
        this.correct1();
        this.display[5] = "none";
        this.display[6] = "block";

      } else {
        this.incorrect();
      }

    },
    validate_free3() {
      if (1 == 1) {
        this.correct1();
        this.display[6] = "none";
        this.display[7] = "block";

      } else {
        this.incorrect();
      }

    },
    validate_five() {
      if (this.seven == "pobj" && this.eight == "0") {
        this.correct1();
        this.display[7] = "none";
        this.display[8] = "block";

      } else {
        this.incorrect();
      }

    },
    validate_free4() {
      if (1 == 1) {
        this.correct1();
        this.display[8] = "none";
        this.display[9] = "block";

      } else {
        this.incorrect();
      }

    },
    validate_six() {
      if (this.nine == "Exec" && this.ten == "pobj") {
        this.correct1();
        this.display[9] = "none";
        this.display[10] = "block";

      } else {
        this.incorrect();
      }

    },
    validate_free5() {
      if (1 == 1) {
        this.correct1();
        this.display[10] = "none";
        this.display[11] = "block";

      } else {
        this.incorrect();
      }

    },
    validate_seven() {
      if (this.eleven == "Exec" && this.twelve == "pobj" && this.thirteen == "1") {
        this.correct1();
        this.display[11] = "none";
        this.display[12] = "block";

      } else {
        this.incorrect();
      }
    },
    validate_free6() {
      if (1 == 1) {
        this.correct1();
        this.display[12] = "none";
        this.display[13] = "block";

      } else {
        this.incorrect();
      }

    },
    validate_eight() {
      if (this.fourteen == "ClassCastException" && this.fifteen == "instanceof") {
        this.correct1();
        this.display[13] = "none";
        this.display[14] = "block";

      } else {
        this.incorrect();
      }
    },

    validate_nine() {
      if (this.sixteen == "NullPointerException") {
        this.correct1();
        this.display[14] = "none";
        this.display[15] = "block";
        this.$emit('oneTestDriverCompleted', true);
      } else {
        this.incorrect();
      }
    },

    },


  data() {
    return {
      id: 'container',
      class: 'wrapper',
      currentComponent: 'constructorWritingComponent',
      button_value: 'Next',
      button_text: "Incorrect. Try again",
      button_text_right: "Correct. Next",
      correct: false,
      valid : [false,false,false,false,false,false,false],
      display: ["block", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none", "none",]
    }
  }

}

</script>
<template>
  <main class="app">
    <div id="snackbar">Some text some message..</div>

    <div id="myModal">
            <div class="modal-content">
              <span class="close">&times;</span>
              <component v-bind:is=currentComponent />
            </div>
          </div>
    
      <div class="column" style="position:sticky; top: 22%; left: 65%; bottom: 10%; float: right">
      <div class="column">
        <div class="codebox">
          <h5>Test Driver: </h5>
          <ul style="line-height: 125%;">
            <li>Write a TestDriver class that has a RentalSystem object.</li>
            <li>Create an ArrayList of type Person and populate it with objects of type Exec and Customer as mentioned in the comments. </li>
            <li>Create a execObj array and populate it with pobj[0] and check. Type cast the object to fix any issues that might arise.</li>
            <li>Initialise the array with pobj[1], observe what happens, and type cast it to the correct type, understand the exception. </li>
            <li>Write try-catch blocks  with appropriate exceptions to fix the errors.</li>
            <li>Create a Customer array cobj and populate it with objects of type Customer.</li>
            <li>Create a Vehicle array and populate it with a Vehicle object with regNum as 1234.</li>
            <li>Create a date object d, and use it to call the setBookingDate function, and set the contract status to "Reservation not released"</li>
            <li>Observe any errors that appear and write try-catch blocks to handle the same.</li>
            <li>Call the visitOffice method by passing the correct object as parameter.</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row">

      <div style="display: flex; flex-direction: row;">
        <div style="flex:5">
          <h1 style="padding: 25px; padding-bottom: 0px;">Coding the Test Driver</h1>
        <p style="padding: 25px; padding-top: 0px">Create the required objects and manipulate them by calling the right functions with arguments to reserve a car.</p>

        </div>
        <!--help buttons-->
        <div style="flex:1">
          <button style="float: right; margin-bottom: 30px;" :style="{ display: display[0] }" @click="popup('arrayListComponent')" class="button-30">Help</button>
          <button style="float: right; margin-bottom: 30px;" :style="{ display: display[1] }" @click="popup('addToArrayComponent')" class="button-30">Help</button>
          <button style="float: right; margin-bottom: 30px;" :style="{ display: display[2] }" @click="popup('addToArrayComponent')" class="button-30">Help</button>
          <button style="float: right; margin-bottom: 30px;" :style="{ display: display[3] }" @click="popup('arrayListComponent')" class="button-30">Help</button>
          <button style="float: right; margin-bottom: 30px;" :style="{ display: display[7] }" @click="popup('arrayOfObjects')" class="button-30">Help</button>
          <button style="float: right; margin-bottom: 30px;" :style="{ display: display[9] }" @click="popup('typeCastingComponent')" class="button-30">Help</button>
          <button style="float: right; margin-bottom: 30px;" :style="{ display: display[11] }" @click="popup('typeCastingComponent')" class="button-30">Help</button>
          <button style="float: right; margin-bottom: 30px;" :style="{ display: display[13] }" @click="popup('classCastExceptionComponent')" class="button-30">Help</button>
          <button style="float: right; margin-bottom: 30px;" :style="{ display: display[14] }" @click="popup('nullPointerExceptionComponent')" class="button-30">Help</button>
        
      
        </div>
        
      </div>


      <div class="column">
        
        <div class="codebox" id="codebox" :style="{ display: display[0] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		
		RentalSystem rentalSystem = new RentalSystem();

</pre>
          &emsp;&emsp;&emsp;ArrayList&lt;<input spellcheck="false" id="one" v-model="one" maxlength="6"
                                                style="width: 80px">&gt; pobj = new <input spellcheck="false" id="two"
                                                                                           v-model="two" maxlength="9"
                                                                                           style="width: 100px"> &lt;&gt;();
          <p id="comment">//Create an arraylist of type person</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_one()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[1] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		
		RentalSystem rentalSystem = new RentalSystem();
   
               ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();

</pre>
          &emsp;&emsp;&emsp;pobj.<input spellcheck="false" id="three" v-model="three" maxlength="3"
                                        style="width: 50px">(new <input spellcheck="false" id="four" v-model="four"
                                                                        maxlength="5"
                                                                        style="width: 80px">("EFG", "efg@gmail.com"));
          <p id="comment">//Populate the ArrayList with an object of type Exec</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_two()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[2] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		
		RentalSystem rentalSystem = new RentalSystem();
   
               ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
               pobj.add(new Exec("EFG", "efg@gmail.com"));

</pre>
          &emsp;&emsp;&emsp;pobj.<input spellcheck="false" id="five" v-model="five" maxlength="3"
                                        style="width: 50px">(new <input spellcheck="false" id="six" v-model="six"
                                                                        maxlength="8"
                                                                        style="width: 100px">("ABC", "abc@gmail.com"));
          <p id="comment">//Populate the ArrayList with an object of type Customer</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_three()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[3] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		
  RentalSystem rentalSystem = new RentalSystem();
   
         ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
         pobj.add(new Exec("EFG", "efg@gmail.com"));
         pobj.add(new Customer("ABC", "abc@gmail.com"));
         pobj.add(new Customer("DEF", 8654678976L));
         pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
         System.out.println("list of Person: [");
         displayAll(pobj);
         System.out.println("]");
</pre>
          &emsp;&emsp;&emsp;ArrayList&lt;<input spellcheck="false" id="seven" v-model="a" maxlength="8"
                                                style="width: 90px">&gt; pobj1 = new <input spellcheck="false" id="two"
                                                                                            v-model="b" maxlength="9"
                                                                                            style="width: 100px"> &lt;&gt;();
          <p id="comment">//Create an arraylist of type Customer with object name "pobj1"</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_four()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[4] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		
  RentalSystem rentalSystem = new RentalSystem();
   
         ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
         pobj.add(new Exec("EFG", "efg@gmail.com"));
         pobj.add(new Customer("ABC", "abc@gmail.com"));
         pobj.add(new Customer("DEF", 8654678976L));
         pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));

         ArrayList&lt;Customer&gt; pobj1= new ArrayList&lt;&gt;();
         pobj1.add(new Customer("ABC", "abc@gmail.com"));
         pobj1.add(new Customer("DEF", 8654678976L));
         pobj1.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
         System.out.println("list of Customer: [");
         displayAll(pobj1);
         System.out.println("]");

         ArrayList&lt;Exec&gt; pobj2= new ArrayList&lt;&gt;();
         pobj2.add(new Exec("ABC1", "abc1@gmail.com"));
         pobj2.add(new Exec("DEF1", 8654678976L));
         pobj2.add(new Exec("GHI1", "ghi1@gmail.com", 1234567890L));
         System.out.println("list of Exec: [");
         displayAll(pobj2);
         System.out.println("]");
</pre>
          <p id="comment">//Similarly Exec type ArrayList is created and populated</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_free()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[5] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		RentalSystem rentalSystem = new RentalSystem();
		
		//step:1 create a person object and initialize with a customer and exec object
		ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
		pobj.add(new Exec("EFG", "efg@gmail.com"));
		pobj.add(new Customer("ABC", "abc@gmail.com"));
		pobj.add(new Customer("DEF", 8654678976L));
		pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Person: [");
		displayAll(pobj);
		System.out.println("]");
		
		ArrayList&lt;Customer&gt; pobj1= new ArrayList&lt;&gt;();
		pobj1.add(new Customer("ABC", "abc@gmail.com"));
		pobj1.add(new Customer("DEF", 8654678976L));
		pobj1.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Customer: [");
		displayAll(pobj1);
		System.out.println("]");
		
		ArrayList&lt;Exec&gt; pobj2= new ArrayList&lt;&gt;();
		pobj2.add(new Exec("ABC1", "abc1@gmail.com"));
		pobj2.add(new Exec("DEF1", 8654678976L));
		pobj2.add(new Exec("GHI1", "ghi1@gmail.com", 1234567890L));
		System.out.println("list of Exec: [");
		displayAll(pobj2);
		System.out.println("]");
		
		System.out.println("Count of persons with Email : " +countPersonWithEmail(pobj));
		System.out.println("Count of persons with Phone : " +countPersonWithPhone(pobj));
		System.out.println("Count of Customer with Email : " +countPersonWithEmail(pobj1));
		System.out.println("Count of Customer with Phone : " +countPersonWithPhone(pobj1));
		System.out.println("Count of Exec with Email : " +countPersonWithEmail(pobj2));
		System.out.println("Count of Exec with Phone : " +countPersonWithPhone(pobj2));
		
		System.out.println("Count of Customers in the list : " +countCustomer(pobj));
		System.out.println("Count of Customers in the list : " +countCustomer(pobj1));
</pre>
          &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<b style="font-size: small;">System.out.println("Count of Customers in
          the list : " +countCustomer(pobj2));</b>
          <div class="outbox">
            <p>ERROR</p>
            <p>Compiler Error.</p>
          </div>
          <br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_free2()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[6] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		RentalSystem rentalSystem = new RentalSystem();
		
		//step:1 create a person object and initialize with a customer and exec object
		ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
		pobj.add(new Exec("EFG", "efg@gmail.com"));
		pobj.add(new Customer("ABC", "abc@gmail.com"));
		pobj.add(new Customer("DEF", 8654678976L));
		pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Person: [");
		displayAll(pobj);
		System.out.println("]");
		
		ArrayList&lt;Customer&gt; pobj1= new ArrayList&lt;&gt;();
		pobj1.add(new Customer("ABC", "abc@gmail.com"));
		pobj1.add(new Customer("DEF", 8654678976L));
		pobj1.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Customer: [");
		displayAll(pobj1);
		System.out.println("]");
		
		ArrayList&lt;Exec&gt; pobj2= new ArrayList&lt;&gt;();
		pobj2.add(new Exec("ABC1", "abc1@gmail.com"));
		pobj2.add(new Exec("DEF1", 8654678976L));
		pobj2.add(new Exec("GHI1", "ghi1@gmail.com", 1234567890L));
		System.out.println("list of Exec: [");
		displayAll(pobj2);
		System.out.println("]");
		
		System.out.println("Count of persons with Email : " +countPersonWithEmail(pobj));
		System.out.println("Count of persons with Phone : " +countPersonWithPhone(pobj));
		System.out.println("Count of Customer with Email : " +countPersonWithEmail(pobj1));
		System.out.println("Count of Customer with Phone : " +countPersonWithPhone(pobj1));
		System.out.println("Count of Exec with Email : " +countPersonWithEmail(pobj2));
		System.out.println("Count of Exec with Phone : " +countPersonWithPhone(pobj2));
		
		System.out.println("Count of Customers in the list : " +countCustomer(pobj));
		System.out.println("Count of Customers in the list : " +countCustomer(pobj1));
		//System.out.println("Count of Customers in the list : " +countCustomer(pobj2));
		System.out.println("Count of Execs in the list : " +countExec(pobj));

</pre>
          &emsp;&emsp;&emsp;<pre>
                System.out.println("Count of Execs in the list : " +countExec(pobj2));
   </pre>
          } <br>
          <button class="button-9" id="btn1" @click="validate_free3()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[7] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		RentalSystem rentalSystem = new RentalSystem();
		
		//step:1 create a person object and initialize with a customer and exec object
		ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
		pobj.add(new Exec("EFG", "efg@gmail.com"));
		pobj.add(new Customer("ABC", "abc@gmail.com"));
		pobj.add(new Customer("DEF", 8654678976L));
		pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Person: [");
		displayAll(pobj);
		System.out.println("]");
		
		ArrayList&lt;Customer&gt; pobj1= new ArrayList&lt;&gt;();
		pobj1.add(new Customer("ABC", "abc@gmail.com"));
		pobj1.add(new Customer("DEF", 8654678976L));
		pobj1.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Customer: [");
		displayAll(pobj1);
		System.out.println("]");
		
		ArrayList&lt;Exec&gt; pobj2= new ArrayList&lt;&gt;();
		pobj2.add(new Exec("ABC1", "abc1@gmail.com"));
		pobj2.add(new Exec("DEF1", 8654678976L));
		pobj2.add(new Exec("GHI1", "ghi1@gmail.com", 1234567890L));
		System.out.println("list of Exec: [");
		displayAll(pobj2);
		System.out.println("]");
		
		System.out.println("Count of persons with Email : " +countPersonWithEmail(pobj));
		System.out.println("Count of persons with Phone : " +countPersonWithPhone(pobj));
		System.out.println("Count of Customer with Email : " +countPersonWithEmail(pobj1));
		System.out.println("Count of Customer with Phone : " +countPersonWithPhone(pobj1));
		System.out.println("Count of Exec with Email : " +countPersonWithEmail(pobj2));
		System.out.println("Count of Exec with Phone : " +countPersonWithPhone(pobj2));
		
		System.out.println("Count of Customers in the list : " +countCustomer(pobj));
		System.out.println("Count of Customers in the list : " +countCustomer(pobj1));
		//System.out.println("Count of Customers in the list : " +countCustomer(pobj2));//compiler error
		
		System.out.println("Count of Execs in the list : " +countExec(pobj));
		//System.out.println("Count of Execs in the list : " +countExec(pobj1)); //compiler error
		System.out.println("Count of Execs in the list : " +countExec(pobj2));
		
		rentalSystem.execobj=new Exec[1];	
</pre>
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;rentalSystem.execobj[0]=
          <input spellcheck="false" maxlength="4" v-model="seven" style="width: 50px;">.get(
          <input spellcheck="false" maxlength="1" v-model="eight" style="width: 15px; padding: 2px;">
          );
          <p id="comment">//Initialize the exec object with pobj[0] and check</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_five()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[8] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		RentalSystem rentalSystem = new RentalSystem();
		
		//step:1 create a person object and initialize with a customer and exec object
		ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
		pobj.add(new Exec("EFG", "efg@gmail.com"));
		pobj.add(new Customer("ABC", "abc@gmail.com"));
		pobj.add(new Customer("DEF", 8654678976L));
		pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Person: [");
		displayAll(pobj);
		System.out.println("]");
		
		ArrayList&lt;Customer&gt; pobj1= new ArrayList&lt;&gt;();
		pobj1.add(new Customer("ABC", "abc@gmail.com"));
		pobj1.add(new Customer("DEF", 8654678976L));
		pobj1.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Customer: [");
		displayAll(pobj1);
		System.out.println("]");
		
		ArrayList&lt;Exec&gt; pobj2= new ArrayList&lt;&gt;();
		pobj2.add(new Exec("ABC1", "abc1@gmail.com"));
		pobj2.add(new Exec("DEF1", 8654678976L));
		pobj2.add(new Exec("GHI1", "ghi1@gmail.com", 1234567890L));
		System.out.println("list of Exec: [");
		displayAll(pobj2);
		System.out.println("]");
		
		System.out.println("Count of persons with Email : " +countPersonWithEmail(pobj));
		System.out.println("Count of persons with Phone : " +countPersonWithPhone(pobj));
		System.out.println("Count of Customer with Email : " +countPersonWithEmail(pobj1));
		System.out.println("Count of Customer with Phone : " +countPersonWithPhone(pobj1));
		System.out.println("Count of Exec with Email : " +countPersonWithEmail(pobj2));
		System.out.println("Count of Exec with Phone : " +countPersonWithPhone(pobj2));
		
		System.out.println("Count of Customers in the list : " +countCustomer(pobj));
		System.out.println("Count of Customers in the list : " +countCustomer(pobj1));
		//System.out.println("Count of Customers in the list : " +countCustomer(pobj2));//compiler error
		
		System.out.println("Count of Execs in the list : " +countExec(pobj));
		//System.out.println("Count of Execs in the list : " +countExec(pobj1)); //compiler error
		System.out.println("Count of Execs in the list : " +countExec(pobj2));
		
		rentalSystem.execobj=new Exec[1];
		rentalSystem.execobj[0]=pobj.get(0);
</pre>

          } <br>
          <div class="outbox">
            <p>ERROR</p>
            <p>Type mismatch. An object of type Person cannot be saved in an array of type Exec</p>
          </div>
          <button class="button-9" id="btn1" @click="validate_free4()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[9] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		RentalSystem rentalSystem = new RentalSystem();
		
		//step:1 create a person object and initialize with a customer and exec object
		ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
		pobj.add(new Exec("EFG", "efg@gmail.com"));
		pobj.add(new Customer("ABC", "abc@gmail.com"));
		pobj.add(new Customer("DEF", 8654678976L));
		pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Person: [");
		displayAll(pobj);
		System.out.println("]");
		
		ArrayList&lt;Customer&gt; pobj1= new ArrayList&lt;&gt;();
		pobj1.add(new Customer("ABC", "abc@gmail.com"));
		pobj1.add(new Customer("DEF", 8654678976L));
		pobj1.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Customer: [");
		displayAll(pobj1);
		System.out.println("]");
		
		ArrayList&lt;Exec&gt; pobj2= new ArrayList&lt;&gt;();
		pobj2.add(new Exec("ABC1", "abc1@gmail.com"));
		pobj2.add(new Exec("DEF1", 8654678976L));
		pobj2.add(new Exec("GHI1", "ghi1@gmail.com", 1234567890L));
		System.out.println("list of Exec: [");
		displayAll(pobj2);
		System.out.println("]");
		
		System.out.println("Count of persons with Email : " +countPersonWithEmail(pobj));
		System.out.println("Count of persons with Phone : " +countPersonWithPhone(pobj));
		System.out.println("Count of Customer with Email : " +countPersonWithEmail(pobj1));
		System.out.println("Count of Customer with Phone : " +countPersonWithPhone(pobj1));
		System.out.println("Count of Exec with Email : " +countPersonWithEmail(pobj2));
		System.out.println("Count of Exec with Phone : " +countPersonWithPhone(pobj2));
		
		System.out.println("Count of Customers in the list : " +countCustomer(pobj));
		System.out.println("Count of Customers in the list : " +countCustomer(pobj1));
		//System.out.println("Count of Customers in the list : " +countCustomer(pobj2));//compiler error
		
		System.out.println("Count of Execs in the list : " +countExec(pobj));
		//System.out.println("Count of Execs in the list : " +countExec(pobj1)); //compiler error
		System.out.println("Count of Execs in the list : " +countExec(pobj2));
		
		rentalSystem.execobj=new Exec[1];		
		//rentalSystem.execobj[0]=pobj.get(0); //compiler error due to type mismatch
</pre>
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          rentalSystem.execobj[0]=(<input spellcheck="false" maxlength="5" v-model="nine" style="width: 60px;">)
          <input spellcheck="false" maxlength="4" v-model="ten" style="width: 50px;">.get(0);
          <p id="comment">//Perform the same operation using typecasting to avoid errors</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_six()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[10] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		RentalSystem rentalSystem = new RentalSystem();
		
		//step:1 create a person object and initialize with a customer and exec object
		ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
		pobj.add(new Exec("EFG", "efg@gmail.com"));
		pobj.add(new Customer("ABC", "abc@gmail.com"));
		pobj.add(new Customer("DEF", 8654678976L));
		pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Person: [");
		displayAll(pobj);
		System.out.println("]");
		
		ArrayList&lt;Customer&gt; pobj1= new ArrayList&lt;&gt;();
		pobj1.add(new Customer("ABC", "abc@gmail.com"));
		pobj1.add(new Customer("DEF", 8654678976L));
		pobj1.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Customer: [");
		displayAll(pobj1);
		System.out.println("]");
		
		ArrayList&lt;Exec&gt; pobj2= new ArrayList&lt;&gt;();
		pobj2.add(new Exec("ABC1", "abc1@gmail.com"));
		pobj2.add(new Exec("DEF1", 8654678976L));
		pobj2.add(new Exec("GHI1", "ghi1@gmail.com", 1234567890L));
		System.out.println("list of Exec: [");
		displayAll(pobj2);
		System.out.println("]");
		
		System.out.println("Count of persons with Email : " +countPersonWithEmail(pobj));
		System.out.println("Count of persons with Phone : " +countPersonWithPhone(pobj));
		System.out.println("Count of Customer with Email : " +countPersonWithEmail(pobj1));
		System.out.println("Count of Customer with Phone : " +countPersonWithPhone(pobj1));
		System.out.println("Count of Exec with Email : " +countPersonWithEmail(pobj2));
		System.out.println("Count of Exec with Phone : " +countPersonWithPhone(pobj2));
		
		System.out.println("Count of Customers in the list : " +countCustomer(pobj));
		System.out.println("Count of Customers in the list : " +countCustomer(pobj1));
		//System.out.println("Count of Customers in the list : " +countCustomer(pobj2));//compiler error
		
		System.out.println("Count of Execs in the list : " +countExec(pobj));
		//System.out.println("Count of Execs in the list : " +countExec(pobj1)); //compiler error
		System.out.println("Count of Execs in the list : " +countExec(pobj2));
    
		rentalSystem.execobj=new Exec[1];		
		//rentalSystem.execobj[0]=pobj.get(0); //compiler error due to type mismatch
		rentalSystem.execobj[0]=(Exec)pobj.get(0);
		
</pre>
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          <div class="outbox no-error">
            <p>OUTPUT</p>
            <p style="color: #fff;">Vehicle is available, initiating contract..</p>
            <p style="color: #fff;">Reservation released</p>
            <p style="color: #fff;">Vehicle key handedover</p><br>
            <p style="color: #fff;">Process finished with exit code 0</p>
          </div>
          } <br>
          <button class="button-9" id="btn1" @click="validate_free5()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[11] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		RentalSystem rentalSystem = new RentalSystem();
		
		//step:1 create a person object and initialize with a customer and exec object
		ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
		pobj.add(new Exec("EFG", "efg@gmail.com"));
		pobj.add(new Customer("ABC", "abc@gmail.com"));
		pobj.add(new Customer("DEF", 8654678976L));
		pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Person: [");
		displayAll(pobj);
		System.out.println("]");
		
		ArrayList&lt;Customer&gt; pobj1= new ArrayList&lt;&gt;();
		pobj1.add(new Customer("ABC", "abc@gmail.com"));
		pobj1.add(new Customer("DEF", 8654678976L));
		pobj1.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Customer: [");
		displayAll(pobj1);
		System.out.println("]");
		
		ArrayList&lt;Exec&gt; pobj2= new ArrayList&lt;&gt;();
		pobj2.add(new Exec("ABC1", "abc1@gmail.com"));
		pobj2.add(new Exec("DEF1", 8654678976L));
		pobj2.add(new Exec("GHI1", "ghi1@gmail.com", 1234567890L));
		System.out.println("list of Exec: [");
		displayAll(pobj2);
		System.out.println("]");
		
		System.out.println("Count of persons with Email : " +countPersonWithEmail(pobj));
		System.out.println("Count of persons with Phone : " +countPersonWithPhone(pobj));
		System.out.println("Count of Customer with Email : " +countPersonWithEmail(pobj1));
		System.out.println("Count of Customer with Phone : " +countPersonWithPhone(pobj1));
		System.out.println("Count of Exec with Email : " +countPersonWithEmail(pobj2));
		System.out.println("Count of Exec with Phone : " +countPersonWithPhone(pobj2));
		
		System.out.println("Count of Customers in the list : " +countCustomer(pobj));
		System.out.println("Count of Customers in the list : " +countCustomer(pobj1));
		//System.out.println("Count of Customers in the list : " +countCustomer(pobj2));//compiler error
		
		System.out.println("Count of Execs in the list : " +countExec(pobj));
		//System.out.println("Count of Execs in the list : " +countExec(pobj1)); //compiler error
		System.out.println("Count of Execs in the list : " +countExec(pobj2));
    
		rentalSystem.execobj=new Exec[1];		
		//rentalSystem.execobj[0]=pobj.get(0); //compiler error due to type mismatch
		//rentalSystem.execobj[0]=(Exec)pobj.get(0); //no compiler error or runtime error
		
		//rentalSystem.execobj[0]=pobj.get(1); //compiler error due to type mismatch
</pre>
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          rentalSystem.execobj[0]=(<input spellcheck="false" maxlength="5" v-model="eleven" style="width: 60px;">)
          <input spellcheck="false" maxlength="4" v-model="twelve" style="width: 50px;">.get(
          <input spellcheck="false" maxlength="1" v-model="thirteen" style="width:15px; padding: 2px;">);
          <p id="comment">//Write code to run the last line using typecasting to avoid errors</p><br>
          <p id="comment">//Assign pobj[1] to execobj[0]</p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_seven()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[12] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		RentalSystem rentalSystem = new RentalSystem();
		
		//step:1 create a person object and initialize with a customer and exec object
		ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
		pobj.add(new Exec("EFG", "efg@gmail.com"));
		pobj.add(new Customer("ABC", "abc@gmail.com"));
		pobj.add(new Customer("DEF", 8654678976L));
		pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Person: [");
		displayAll(pobj);
		System.out.println("]");
		
		ArrayList&lt;Customer&gt; pobj1= new ArrayList&lt;&gt;();
		pobj1.add(new Customer("ABC", "abc@gmail.com"));
		pobj1.add(new Customer("DEF", 8654678976L));
		pobj1.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Customer: [");
		displayAll(pobj1);
		System.out.println("]");
		
		ArrayList&lt;Exec&gt; pobj2= new ArrayList&lt;&gt;();
		pobj2.add(new Exec("ABC1", "abc1@gmail.com"));
		pobj2.add(new Exec("DEF1", 8654678976L));
		pobj2.add(new Exec("GHI1", "ghi1@gmail.com", 1234567890L));
		System.out.println("list of Exec: [");
		displayAll(pobj2);
		System.out.println("]");
		
		System.out.println("Count of persons with Email : " +countPersonWithEmail(pobj));
		System.out.println("Count of persons with Phone : " +countPersonWithPhone(pobj));
		System.out.println("Count of Customer with Email : " +countPersonWithEmail(pobj1));
		System.out.println("Count of Customer with Phone : " +countPersonWithPhone(pobj1));
		System.out.println("Count of Exec with Email : " +countPersonWithEmail(pobj2));
		System.out.println("Count of Exec with Phone : " +countPersonWithPhone(pobj2));
		
		System.out.println("Count of Customers in the list : " +countCustomer(pobj));
		System.out.println("Count of Customers in the list : " +countCustomer(pobj1));
		//System.out.println("Count of Customers in the list : " +countCustomer(pobj2));//compiler error
		
		System.out.println("Count of Execs in the list : " +countExec(pobj));
		//System.out.println("Count of Execs in the list : " +countExec(pobj1)); //compiler error
		System.out.println("Count of Execs in the list : " +countExec(pobj2));
    
		rentalSystem.execobj=new Exec[1];		
		//rentalSystem.execobj[0]=pobj.get(0); //compiler error due to type mismatch
		rentalSystem.execobj[0]=(Exec)pobj.get(0); //no compiler error or runtime error
		
		//rentalSystem.execobj[0]=pobj.get(1); //compiler error due to type mismatch
		rentalSystem.execobj[0]=(Exec)pobj.get(1); //no compiler error

</pre>
          <div class="outbox">
            <p>ERROR</p>
            <p>Runtime error
              <br>Exception in thread "main" java.lang.ClassCastException: class Customer cannot be cast to class Exec
              (Customer and Exec are in unnamed module of loader 'app') at TestDriver.main(TestDriver.java:23)</p>
          </div>
          <button class="button-9" id="btn1" @click="validate_free6()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[13] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		RentalSystem rentalSystem = new RentalSystem();
		
		//step:1 create a person object and initialize with a customer and exec object
		ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
		pobj.add(new Exec("EFG", "efg@gmail.com"));
		pobj.add(new Customer("ABC", "abc@gmail.com"));
		pobj.add(new Customer("DEF", 8654678976L));
		pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Person: [");
		displayAll(pobj);
		System.out.println("]");
		
		ArrayList&lt;Customer&gt; pobj1= new ArrayList&lt;&gt;();
		pobj1.add(new Customer("ABC", "abc@gmail.com"));
		pobj1.add(new Customer("DEF", 8654678976L));
		pobj1.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Customer: [");
		displayAll(pobj1);
		System.out.println("]");
		
		ArrayList&lt;Exec&gt; pobj2= new ArrayList&lt;&gt;();
		pobj2.add(new Exec("ABC1", "abc1@gmail.com"));
		pobj2.add(new Exec("DEF1", 8654678976L));
		pobj2.add(new Exec("GHI1", "ghi1@gmail.com", 1234567890L));
		System.out.println("list of Exec: [");
		displayAll(pobj2);
		System.out.println("]");
		
		System.out.println("Count of persons with Email : " +countPersonWithEmail(pobj));
		System.out.println("Count of persons with Phone : " +countPersonWithPhone(pobj));
		System.out.println("Count of Customer with Email : " +countPersonWithEmail(pobj1));
		System.out.println("Count of Customer with Phone : " +countPersonWithPhone(pobj1));
		System.out.println("Count of Exec with Email : " +countPersonWithEmail(pobj2));
		System.out.println("Count of Exec with Phone : " +countPersonWithPhone(pobj2));
		
		System.out.println("Count of Customers in the list : " +countCustomer(pobj));
		System.out.println("Count of Customers in the list : " +countCustomer(pobj1));
		//System.out.println("Count of Customers in the list : " +countCustomer(pobj2));//compiler error
		
		System.out.println("Count of Execs in the list : " +countExec(pobj));
		//System.out.println("Count of Execs in the list : " +countExec(pobj1)); //compiler error
		System.out.println("Count of Execs in the list : " +countExec(pobj2));
    
		rentalSystem.execobj=new Exec[1];		
		//rentalSystem.execobj[0]=pobj.get(0); //compiler error due to type mismatch
		rentalSystem.execobj[0]=(Exec)pobj.get(0); //no compiler error or runtime error
		
		//rentalSystem.execobj[0]=pobj.get(1); //compiler error due to type mismatch
		rentalSystem.execobj[0]=(Exec)pobj.get(1); //no compiler error

    try
		{
			rentalSystem.execobj[0]=(Exec)pobj.get(1);
		}
</pre>
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          catch(<input spellcheck="false" maxlength="18" v-model="fourteen" style="width: 145px;"> e)
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;{
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;if(pobj.get(1)

          <input spellcheck="false" maxlength="10" v-model="fifteen" style="width: 90px;"> Exec)
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;rentalSystem.execobj[0] =(Exec)
          pobj.get(1);
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;}
          <p id="comment">//Resolve using try-catch block with exception that deals with class casting and instanceof
            method </p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_eight()"> {{ button_value }}</button>
        </div>

        <div class="codebox" id="codebox" :style="{ display: display[14] }">
          <pre>
import java.util.Scanner;
import java.util.ArrayList;
import java.text.ParseException;
import java.text.SimpleDateFormat;
import java.util.Date;
import java.lang.*;

public class TestDriver {
	
	public static void main(String[] args) throws ParseException {
		// TODO Auto-generated method stub
		
		RentalSystem rentalSystem = new RentalSystem();
		
		//step:1 create a person object and initialize with a customer and exec object
		ArrayList&lt;Person&gt; pobj= new ArrayList&lt;&gt;();
		pobj.add(new Exec("EFG", "efg@gmail.com"));
		pobj.add(new Customer("ABC", "abc@gmail.com"));
		pobj.add(new Customer("DEF", 8654678976L));
		pobj.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Person: [");
		displayAll(pobj);
		System.out.println("]");
		
		ArrayList&lt;Customer&gt; pobj1= new ArrayList&lt;&gt;();
		pobj1.add(new Customer("ABC", "abc@gmail.com"));
		pobj1.add(new Customer("DEF", 8654678976L));
		pobj1.add(new Customer("GHI", "ghi@gmail.com", 1234567890L));
		System.out.println("list of Customer: [");
		displayAll(pobj1);
		System.out.println("]");
		
		ArrayList&lt;Exec&gt; pobj2= new ArrayList&lt;&gt;();
		pobj2.add(new Exec("ABC1", "abc1@gmail.com"));
		pobj2.add(new Exec("DEF1", 8654678976L));
		pobj2.add(new Exec("GHI1", "ghi1@gmail.com", 1234567890L));
		System.out.println("list of Exec: [");
		displayAll(pobj2);
		System.out.println("]");
		
		System.out.println("Count of persons with Email : " +countPersonWithEmail(pobj));
		System.out.println("Count of persons with Phone : " +countPersonWithPhone(pobj));
		System.out.println("Count of Customer with Email : " +countPersonWithEmail(pobj1));
		System.out.println("Count of Customer with Phone : " +countPersonWithPhone(pobj1));
		System.out.println("Count of Exec with Email : " +countPersonWithEmail(pobj2));
		System.out.println("Count of Exec with Phone : " +countPersonWithPhone(pobj2));
		
		System.out.println("Count of Customers in the list : " +countCustomer(pobj));
		System.out.println("Count of Customers in the list : " +countCustomer(pobj1));
		
		
		System.out.println("Count of Execs in the list : " +countExec(pobj));
		
		System.out.println("Count of Execs in the list : " +countExec(pobj2));
    
		rentalSystem.execobj=new Exec[1];		
		
    try
		{
			rentalSystem.execobj[0]=(Exec)pobj.get(1);
		}
		catch(ClassCastException e)
		{
			if(pobj.get(1) instanceof Exec)
				rentalSystem.execobj[0] =(Exec) pobj.get(1);
		}
		
		
		rentalSystem.cobj= new Customer[3];
		rentalSystem.cobj[0]=(Customer) pobj.get(1);
		rentalSystem.cobj[1]=(Customer) pobj.get(2);
		rentalSystem.cobj[2]=(Customer) pobj.get(3);
		rentalSystem.cobj[0].setCity("Coimbatore");
		rentalSystem.cobj[1].setCity("Coimbatore");
		rentalSystem.cobj[2].setCity("Chennai");
		
		rentalSystem.vobj = new Vehicle[1];
		rentalSystem.vobj[0]=new Vehicle(1234);
		
		rentalSystem.robj=new Reservation[1];
		rentalSystem.robj[0]= new Reservation(rentalSystem.cobj[0],rentalSystem.vobj[0]);
		SimpleDateFormat sdformat = new SimpleDateFormat("yyyy-MM-dd");
    Date d = sdformat.parse("2022-02-29");
		rentalSystem.robj[0].setBookingDate(d);
		rentalSystem.robj[0].setContractStatus("Reservation not released");
		
		
    try
		{
			rentalSystem.visitOffice(rentalSystem.robj[0]);
		}
</pre>
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          catch(<input spellcheck="false" maxlength="20" v-model="sixteen" style="width: 150px;"> e)
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;{
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;System.out.println("wait for exec to be assigned");
          <br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;}
          <p id="comment">//Resolve using a try-catch block to handle the NullPointerException </p><br>
          } <br>
          <button class="button-9" id="btn1" @click="validate_nine()"> {{ button_value }}</button>
        </div>


       </div>
    </div>
  </main>
</template>

<style scoped>
* {
  box-sizing: border-box;
  background-color: #F9FAFE;
}

h1,
h2,
p {
  font-family: sans-serif;
  color: rgb(0, 3, 40);
}

.column {
  float: left;
  width: 50%;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

.completed {
    color: cadetblue;
    text-decoration: line-through;
}


mark1 {
  background-color: rgb(176, 230, 183);
  box-shadow: 1px 6px 15px 2px rgb(160, 222, 159);
  color: black;
  border-radius: 10px;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
}

mark0 {
  box-shadow: 1px 6px 15px 2px rgb(249, 255, 191);
  background-color: rgb(231, 238, 162);
  color: black;
  border-radius: 10px;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
}

#comment {
  margin-left: 15px;
  font-style: italic;
  color: gray;
  font-size: small;
}

.codebox {
    margin: 30px;
    height: fit-content;
    width: fit-content;
    padding: 25px;
    border-radius: 10px;
    background-color: #F9FAFE;
    box-shadow: 2px 3px 10px 2px #D7DFFF;
  }

.outbox {
    height: fit-content;
    min-height: 10vh;
    width: 90%;
    margin: 25px;
    padding: 25px;
    border-radius: 10px;
    background-color: #202020;
    color: red;
    font-size: medium;
    font-family: monospace;
    font-weight: bold;
    box-shadow: 2px 3px 10px 2px #D7DFFF;
}

.no-error{
  color: white;
}

.outbox p{
    background-color: inherit;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
}


input {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  color: black;
}

/* CSS */
.button-9 {
  appearance: button;
  backface-visibility: hidden;
  background-color: #405cf5;
  border-radius: 6px;
  border-width: 0;
  box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .1) 0 2px 5px 0, rgba(0, 0, 0, .07) 0 1px 1px 0;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  font-family: -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Ubuntu, sans-serif;
  font-size: 100%;
  height: 44px;
  line-height: 1.15;
  margin: 12px 0 0;
  outline: none;
  overflow: hidden;
  padding: 0 25px;
  position: relative;
  text-align: center;
  text-transform: none;
  transform: translateZ(0);
  transition: all .2s, box-shadow .08s ease-in;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 200px;
}

.button-9:disabled {
  cursor: default;
}

.button-9:focus {
  box-shadow: rgba(50, 50, 93, .1) 0 0 0 1px inset, rgba(50, 50, 93, .2) 0 6px 15px 0, rgba(0, 0, 0, .1) 0 2px 2px 0, rgba(50, 151, 211, .3) 0 0 0 4px;
}

#snackbar {
  visibility: hidden;
  min-width: 250px;
  margin-left: -125px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 50%;
  bottom: 30px;
  font-size: 17px;
}

#snackbar.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

.button-30 {
  align-items: center;
  appearance: none;
  width: fit-content;
  background-color: #FCFCFD;
  border-radius: 4px;
  border-width: 0;
  box-shadow: rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;
  box-sizing: border-box;
  color: #36395A;
  cursor: pointer;
  display: inline-flex;
  font-family: "JetBrains Mono", monospace;
  height: 48px;
  justify-content: center;
  line-height: 1;
  list-style: none;
  overflow: hidden;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  position: relative;
  text-align: left;
  text-decoration: none;
  transition: box-shadow .15s, transform .15s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  will-change: box-shadow, transform;
  font-size: 18px;
}

.button-30:focus {
  box-shadow: #D6D6E7 0 0 0 1.5px inset, rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;
}

.button-30:hover {
  box-shadow: rgba(45, 35, 66, 0.4) 0 4px 8px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;
  transform: translateY(-2px);
}

.button-30:active {
  box-shadow: #D6D6E7 0 3px 7px inset;
  transform: translateY(2px);
}

#myModal {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 100px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}


</style>
 